export const adjectives = [
  'bright',
  'wild',
  'green',
  'swift',
  'calm',
  'gentle',
  'bold',
  'fresh',
  'clear',
  'deep',
  'warm',
  'pure',
  'tall',
  'soft',
  'cool',
  'free',
  'kind',
  'wise',
  'fair',
  'lush',
  'quiet',
  'vivid',
  'noble',
  'hardy',
];

export const nouns = [
  'oak',
  'pine',
  'fern',
  'moss',
  'leaf',
  'forest',
  'grove',
  'meadow',
  'river',
  'stream',
  'breeze',
  'earth',
  'stone',
  'cloud',
  'wave',
  'glen',
  'vale',
  'cove',
  'peak',
  'ridge',
  'bloom',
  'dawn',
  'dusk',
];
